import { code } from "@spscommerce/utils";
import { DSReactExamples } from "@spscommerce/ds-shared";

export const SpsTextInputExamples: DSReactExamples = {
    standard: {
        label: "Standard",
        description: "info about standard text inputs",
        examples: {
            standard: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: "bar" });

                        return <>
                            <SpsLabel for={formMeta.fields.foo}>Foo</SpsLabel>
                            <SpsTextInput
                                value={formValue.foo}
                                formMeta={formMeta.fields.foo}
                            />
                        </>;
                    }
                `
            }
        }
    },
    b_placeholder: {
        label: "Placeholder",
        description: "info about text input placeholders",
        examples: {
            placeholder: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: "bar" });

                        return <>
                                <SpsLabel for={formMeta.fields.foo}>
                                    Company Name
                                </SpsLabel>
                                <SpsTextInput formMeta={formMeta.fields.foo}
                                    value={formValue.foo}
                                    placeholder="Enter a company name"
                                ></SpsTextInput>
                            </>
                    }
                `
            }
        }
    },
    c_description: {
        label: "Description",
        description: "info about text inputs with descriptions",
        examples: {
            description: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: "bar" });

                        return <>
                                <SpsLabel for={formMeta.fields.foo}
                                    value={formValue.foo}
                                    description="This is a brief description of the field to provide additional context."
                                >
                                    Label
                                </SpsLabel>
                                <SpsTextInput formMeta={formMeta.fields.foo}/>
                            </>
                    }
                `
            }
        }
    },
    d_disabled: {
        label: "Disabled",
        description: "info about disabled text inputs",
        examples: {
            disabled: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({ email: "foo@bar.com" });

                        return <>
                                <SpsLabel for={formMeta.fields.email}>
                                    Email Address
                                </SpsLabel>
                                <SpsTextInput id="disabledTextInput" disabled
                                    value={formValue.email}
                                    formMeta={formMeta.fields.email}
                                ></SpsTextInput>
                            </>
                    }
                `
            }
        }
    }
};
